import Repository from "./Repository";

export default {
  /**
   * 設定取得 (表示用) ※public
   * @param {*} shopId 
   * @returns 
   */
  getSettings (shopId) {
    const config = {
      headers: {
      },
    };
    return Repository.get(`/${shopId}/settings`, config);
  },

  /**
   * liffId 取得 ※public
   * @param {*} shopId 
   * @returns 
   */
  getLiffId (shopId) {
    const config = {
      headers: {
      },
    };
    return Repository.get(`/${shopId}/liffId`, config);
  },

  /**
   * Firebase Auth カスタムトークン作成
   * @param {*} lineToken 
   * @returns 
   */
  getCustomToken (shopId, lineToken) {
    const config = {
      headers: {
        lineToken: lineToken ?? "",
      },
    };
    return Repository.get(`/${shopId}/customToken`, config);
  },
  isServiceStatusActive (shopId, headers) {
    const config = {
      headers: this._createHeaders(headers),
    };
    return Repository.get(`/${shopId}/serviceStatusActive`, config);
  },
  getReceivableSetting (shopId, headers) {
    const config = {
      headers: this._createHeaders(headers),
    };
    return Repository.get(`/${shopId}/receivableSetting`, config);
  },
  validateVisitTime (shopId, headers, params) {
    const config = {
      headers: this._createHeaders(headers),
    };
    const query = `visitTimeYMD=${params.visitTimeYMD}&visitTimeHHMM=${params.visitTimeHHMM}`;
    return Repository.get(`/${shopId}/validateVisitTime?${query}`, config);
  },
  getUserOrderStatusRecent (shopId, headers) {
    const config = {
      headers: this._createHeaders(headers),
    };
    return Repository.get(`/${shopId}/order/userOrderStatus/recent`, config);
  },
  checkItemsInCart (shopId, headers) {
    const config = {
      headers: this._createHeaders(headers),
    };
    return Repository.get(`/${shopId}/cart/checkItems`, config);
  },

  _createHeaders (headers) {
    return {
      lineToken: headers?.lineToken ?? "",
      idToken: headers?.idToken ?? "",
    };
  }
}
